import classNames from 'classnames';
import React from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import styles from './TeamIcon.module.scss';

interface TeamIconProps {
  size?: 'small' | 'regular' | 'medium' | 'large' | 'xlarge';
}

const TeamIcon = ({ size = 'regular' }: TeamIconProps) => {
  const sessionOrg = useAppSelector((state) => state.session.organization);
  const publicOrg = window.__slab.PUBLIC_ORG;

  const organization = sessionOrg.id ? sessionOrg : publicOrg;
  const { name } = organization;
  const logo = organization?.logo?.thumb || null;

  const classes = classNames(styles.teamIconDefault, {
    [styles.small]: size === 'small',
    [styles.regular]: size === 'regular',
    [styles.medium]: size === 'medium',
    [styles.large]: size === 'large',
    [styles.xlarge]: size === 'xlarge',
    [styles.withBackground]: logo === null,
  });

  const firstLetterInName = name[0];
  return logo ? (
    <span className={classes} style={{ backgroundImage: `url(${logo})` }} />
  ) : (
    <span className={classes}>{firstLetterInName?.toUpperCase()}</span>
  );
};

export default TeamIcon;
